module.exports = __webpack_public_path__ + "static/media/Camps.65b37864.png";